import { vhmformapi } from "@src/proto/formapi";

vhmformapi.autodebit.AutoDebitFormService;
export async function fetchFormData(
  body: vhmformapi.autodebit.ISubmitLoginInput
): Promise<vhmformapi.autodebit.ISubmitLoginOutput | { code: unknown }> {
  let json;
  try {
    json = JSON.stringify(body);
  } catch (error) {
    return { code: error };
  }
  const res = await fetch(
    `/vhmformapi.autodebit.AutoDebitFormService/SubmitLogin`,
    {
      method: "POST",
      body: json,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return await res.json();
}
